import * as THREE from 'three';
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';
import { Object3D } from "./Viewer.Object3D.js";

// const _axis = /*@__PURE__*/ new THREE.Vector3();

class MomentHelper extends Object3D {
    constructor(components, labelText, lineMaterial, meshMaterial, color, radius = 0.3) {
        super();

        this.type = 'MomentHelper';

        this.components = new THREE.Vector3(...components);
        this.dir = this.components.clone().normalize().multiplyScalar( -1 );

        this.origin = new THREE.Vector3();
        this.radius = radius;

        this.position.copy( this.origin );

        const curve = new THREE.EllipseCurve(
            0, 0, // ax, aY
            radius, radius, // xRadius, yRadius
            0.25 * Math.PI, 1.75 * Math.PI, // aStartAngle, aEndAngle
            false, // aClockwise
            0 // aRotation
        );
        const points = curve.getPoints(20);
        const geometry = new THREE.BufferGeometry().setFromPoints(points);

        this.line = new THREE.Line( geometry, lineMaterial );
        this.line.matrixAutoUpdate = false;
        this.add( this.line );

        this.cone = new THREE.Mesh(
            new THREE.CylinderGeometry( 0, 0.5, 1, 5, 1 ),
            meshMaterial
        );
        this.cone.matrixAutoUpdate = false;
        this.add( this.cone );

        this.setDirection( this.dir );
        this.setHead( radius );

        this.div = this.createLabelElement(labelText);
        this.label = new CSS2DObject(this.div);
        this.updateLabelPosition();
        this.add( this.label );
    }

    setDirection( dir ) {

        // dir is assumed to be normalized

        //
        // if (dir.y > 0.99999) {
        //
        //     this.quaternion.set(0, 0, 0, 1);
        //
        // } else if (dir.y < -0.99999) {
        //
        //     this.quaternion.set(1, 0, 0, 0);
        //
        // } else {
        //
        //     _axis.set(dir.z, 0, -dir.x).normalize();
        //
        //     const radians = Math.acos(dir.y);
        //
        //     this.quaternion.setFromAxisAngle(_axis, radians);
        //
        // }

        const initDir = new THREE.Vector3(0, 0, 1);
        const quaternion = new THREE.Quaternion().setFromUnitVectors(initDir, dir);
        this.quaternion.copy(quaternion);
    }

    setColor( color ) {

        this.line.material.color.set( color );
        this.cone.material.color.set( color );
        this.div.style.color = color;

    }

    setHead( radius, headLength = 0.8 * radius, headWidth = headLength * 0.5 ) {
        const angle = 0.25 * Math.PI;

        this.cone.scale.set( headWidth, headLength, headWidth );
        this.cone.position.x = Math.sin(angle) * radius;
        this.cone.position.y = Math.sin(angle) * radius;
        this.cone.rotation.z = -angle - 0.43*Math.PI;
        this.cone.updateMatrix();

    }

    copy( source ) {

        super.copy( source, false );

        this.line.copy( source.line );
        this.cone.copy( source.cone );

        return this;

    }

    createLabelElement( text ) {
        const color = this.line.material.color;


        const div = document.createElement('div');
        div.className = 'moment-label';
        div.textContent = text;
        div.style.marginTop = '-1em';
        div.style.padding = '2px 4px';
        // div.style.background = 'rgba(0, 0, 0, 0.5)';
        div.style.color = `rgb(${color.r * 255}, ${color.g * 255}, ${color.b * 255})`;
        div.style.borderRadius = '4px';
        div.style.fontSize = '12px';

        return div;
    }

    updateLabelPosition() {
        const newPosition = new THREE.Vector3(3, 0, -1) //TODO: huh this sucks
            .normalize()
            .multiplyScalar(this.radius)
            .add(this.origin);

        if (this.label) {
            this.label.position.set(newPosition.x, newPosition.y, newPosition.z);
        }
    }

    setScale() {

    }
}

export { MomentHelper };